import React from 'react';
import CenterImage from './../CenterImage/CenterImage';

const TwoFactorAuthImage = () => (
  <CenterImage
    image={
      <svg
        width="114px"
        height="114px"
        viewBox="0 0 114 114"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-9.000000, -9.000000)">
            <g>
              <path
                d="M0,0 L128,0 L128,128 L0,128 L0,0 Z"
                opacity="0.871206975"
              />
              <g transform="translate(10.000000, 10.000000)">
                <polygon
                  fill="#FFFFFF"
                  fillRule="nonzero"
                  points="1 1 113 1 113 113 1 113"
                />
                <g>
                  <path
                    d="M69.8341405,34.1180593 C69.2861918,34.052857 69.290188,34 69.8389928,34 L110,34 L109.757206,74 C109.757206,74 108.661395,65.3627308 98.7972921,50.5453827 C88.9331891,35.7280346 69.8341405,34.1180593 69.8341405,34.1180593 Z"
                    fill="#DFEBEB"
                  />
                  <g>
                    <g>
                      <g>
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="0.5"
                          y="0.5"
                          width="30"
                          height="30"
                        />
                        <rect
                          fill="#7FBABA"
                          x="12"
                          y="10"
                          width="14"
                          height="14"
                        />
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="8.5"
                          y="8.5"
                          width="14"
                          height="14"
                        />
                      </g>
                    </g>
                    <g transform="translate(0.000000, 78.000000)">
                      <g>
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="0.5"
                          y="0.5"
                          width="30"
                          height="30"
                        />
                        <polygon
                          fill="#7FBABA"
                          points="12 10 26 10 26 24 12 24"
                        />
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="8.5"
                          y="8.5"
                          width="14"
                          height="14"
                        />
                      </g>
                    </g>
                    <g transform="translate(78.000000, 78.000000)">
                      <g>
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="0.5"
                          y="0.5"
                          width="30"
                          height="30"
                        />
                        <polygon
                          fill="#7FBABA"
                          points="12 10 26 10 26 24 12 24"
                        />
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="8.5"
                          y="8.5"
                          width="14"
                          height="14"
                        />
                      </g>
                    </g>
                    <g transform="translate(78.000000, 0.000000)">
                      <g>
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="0.5"
                          y="0.5"
                          width="30"
                          height="30"
                        />
                        <polygon
                          fill="#7FBABA"
                          points="12 10 26 10 26 24 12 24"
                        />
                        <rect
                          stroke="#365568"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          x="8.5"
                          y="8.5"
                          width="14"
                          height="14"
                        />
                      </g>
                    </g>
                    <g
                      transform="translate(38.000000, 0.000000)"
                      stroke="#365568"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    >
                      <polyline points="0.5 0.5 0.5 30.5 16.5 30.5 16.5 0.5 32.5 0.5 32.5 30.5" />
                      <path d="M24.5,8.5 L24.5,38.5 L48.5,38.5 M56.4950904,38.5 L70.5,38.5" />
                      <path d="M8.5,0.5 L8.5,12.5 M8.5,20.5 L8.5,22.5" />
                    </g>
                    <g
                      transform="translate(59.500000, 77.500000) rotate(-180.000000) translate(-59.500000, -77.500000) translate(46.500000, 46.500000)"
                      stroke="#365568"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="3"
                    >
                      <path d="M2,0 L2,14 M2,22 L2,38 L26,38 L26,62" />
                    </g>
                    <path
                      d="M62.5,78.5 L38.5,78.5 L38.5,70.5 L20.5,70.5 M12.5,70.5 L0.5,70.5"
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <polyline
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      points="0.5 62.5 38.5 62.5 38.5 46.5 0.5 46.5"
                    />
                    <path
                      d="M0.5,54.5 L30.5,54.5"
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M77.5,70.5 L107.5,70.5"
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M70.5,54.5 L100.5,54.5"
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      x="62.5"
                      y="46.5"
                      width="46"
                      height="16"
                    />
                    <path
                      d="M54.5,62.0877294 L54.5,38.5 L30.5,38.5 M22.5,38.5 L14.5,38.5 M6.5,38.5 L0.5,38.5"
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <polyline
                      stroke="#365568"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      transform="translate(50.584133, 97.705998) rotate(-270.000000) translate(-50.584133, -97.705998) "
                      points="61.7901317 85.6218648 39.3781352 85.7901317 39.3781352 109.790132 61.3781352 109.790132 61.3781352 101.790132 45.3781352 101.790132"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    }
  />
);

export default TwoFactorAuthImage;
